export default "__VITE_ASSET__36683209__"